import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

const API_URL = process.env.REACT_APP_API_URL;

function getFilenameFromDisposition(disposition, fallback) {
  if (!disposition) return fallback;
  const match = disposition.match(/filename\*=UTF-8''(.+)|filename="?([^";]+)"?/i);
  if (!match) return fallback;
  try {
    return decodeURIComponent(match[1] || match[2]);
  } catch {
    return match[1] || match[2] || fallback;
  }
}

function downloadBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

export const downloadProjectLogbook = createAsyncThunk(
  'exports/downloadProjectLogbook',
  async ({ projectNumber }, { signal, rejectWithValue }) => {
    try {
      const resp = await fetch(`${API_URL}/api/export/projects/logbook?projectNumber=${encodeURIComponent(projectNumber)}`, {
        method: 'GET',
        signal,
      });
      if (!resp.ok) {
        const data = await resp.json().catch(() => ({}));
        throw new Error(data?.message || data?.error || "Project number isn't valid");
      }
      const blob = await resp.blob();
      const filename = getFilenameFromDisposition(
        resp.headers.get('content-disposition'),
        `Project ${projectNumber} Logbook.csv`
      );
      downloadBlob(blob, filename);
      return { success: true };
    } catch (e) {
      if (e?.name === 'AbortError') throw e;
      console.error('exports/downloadProjectLogbook failed', e);
      return rejectWithValue(e?.message || 'Failed to download logbook');
    }
  }
);

export const downloadAllProjectsLogbook = createAsyncThunk(
  'exports/downloadAllProjectsLogbook',
  async (_, { signal, rejectWithValue }) => {
    try {
      const resp = await fetch(`${API_URL}/api/export/projects/logbook`, { method: 'GET', signal });
      if (!resp.ok) {
        const data = await resp.json().catch(() => ({}));
        throw new Error(data?.message || data?.error || 'Failed to download logbook');
      }
      const blob = await resp.blob();
      const filename = getFilenameFromDisposition(resp.headers.get('content-disposition'), 'All Projects Logbook.csv');
      downloadBlob(blob, filename);
      return { success: true };
    } catch (e) {
      if (e?.name === 'AbortError') throw e;
      console.error('exports/downloadAllProjectsLogbook failed', e);
      return rejectWithValue(e?.message || 'Failed to download logbook');
    }
  }
);

const slice = createSlice({
  name: 'exports',
  initialState: { error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      (action) => action.type.startsWith('exports/') && action.type.endsWith('/rejected'),
      (state, action) => {
        if (action?.meta?.aborted || action?.error?.name === 'AbortError') return;
        state.error = action.payload || action.error?.message || null;
      }
    );
  },
});

export default slice.reducer;


